import customSelect from 'custom-select'
import { getAll, get } from '@bigyouth/base'

export default {
  name: 'custom-select',

  componentDidMount () {
    const customSelectEl = customSelect(this.el, {
      containerClass: 'custom-select-container',
      openerClass: 'custom-select-opener',
      panelClass: 'custom-select-panel',
      optionClass: 'custom-select-option',
      optgroupClass: 'custom-select-optgroup',
      isSelectedClass: 'is-selected',
      hasFocusClass: 'has-focus',
      isDisabledClass: 'is-disabled',
      isOpenClass: 'is-open',
    })

    const iconContainer = document.createElement('div')
    iconContainer.innerHTML = `
      <div class="custom-select-icon-wrapper">
        <svg class="custom-select-icon icon icon--gray">
          <use href="#icon-chevron-down" xlink:href="#icon-chevron-down"></use>
        </svg>
      </div>
    `

    customSelectEl[0].container.appendChild(iconContainer.firstElementChild)

    const toggleContentContainer = this.el.closest('[js-toggle-content-content]')

    if (toggleContentContainer && toggleContentContainer.classList.contains('is-visible')) {
      toggleContentContainer.style.height = `${this.el.closest('[js-toggle-content-inner]').offsetHeight}px`
    }

    customSelectEl[0].select.addEventListener('change', (e) => {
      if (this.props) {
        if (this.props.isCountry) {
          if (e.target.value !== 'France') {
            window.location.href = `${window.location.pathname}?foreignCountry=${e.target.value}`
          } else {
            window.location.href = window.location.pathname
          }
        } else if (this.props.hasPlaceholder) {
          if (e.target.value === '') {
            this.el.parentNode.parentNode.classList.add('has-placeholder')
          } else {
            this.el.parentNode.parentNode.classList.remove('has-placeholder')
          }
        }

        const selectValue = e.target.value

        if (this.props.participant) {
          getAll('[js-form-validation-field]', this.el.closest('[js-toggle-content]')).forEach(field => {
            if (selectValue === '') {
              if (field !== this.el) {
                field.setAttribute('required', true)
              }
            } else {
              if (field !== this.el) {
                field.removeAttribute('required')

                if (field.type !== 'radio') {
                  field.value = ''
                }
              }
            }
          })

          if (selectValue !== '') {
            getAll('.form__field-error', this.el.closest('[js-toggle-content]')).forEach(error => {
              error.remove()
            })

            getAll('.has-error', this.el.closest('[js-toggle-content]')).forEach(error => {
              error.classList.remove('has-error')
            })
          }
        }

        if (this.props.isInvoicingCountry) {
          const siretInput = get('[data-validation-type="siret"]', this.el.closest('.accordion__content'))
          const starLabel = get('sup', siretInput.previousElementSibling)

          if (selectValue === 'France') {
            siretInput.setAttribute('required', true)
            starLabel.classList.remove('hidden')
          } else {
            siretInput.removeAttribute('required')
            siretInput.value = ''
            starLabel.classList.add('hidden')
          }
        }
      }
    })
  },
}
